import React, { Component } from 'react';
import './style.scss';
import { getQuizStudentAnswers } from './actions';
import Question from './components/Question';
import PropTypes from 'prop-types';

class StudentAnswerQuiz extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      questions: [],
      quiz: {},
      student: {},
      loaded: false,
    }
  }

  async componentDidMount() {
    

    const {quiz_id, answer_id} = this.props.match.params;
    const {questions, quiz, student} = await getQuizStudentAnswers(quiz_id, answer_id)
    this.setState({questions, quiz, student, loaded: true});
  }
  

  render() {
    const {formatMessage} = this.context;
    const {questions, quiz, loaded, student} = this.state;
    if(!loaded){
      return null;
    }
    return (
      <div className="StudentAnswerQuiz qbm-content">
        <div className="question-container">
          <h2>{quiz.title}</h2>
          <h3>{formatMessage('titleAnswerStudentName')}: {student.firstname} {student.lastname}</h3>
          {questions.map(item => <Question item={item} key={'question-' + item.id} quiz={quiz}/>)}
        </div>
      </div>
    );
  }
}

export default StudentAnswerQuiz;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StudentAnswerQuiz/index.jsx